import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/components/copilot/CalvantCopilot.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/components/MainContentWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/components/SidebarWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["FrameworkProvider"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/context/FrameworkContex.js");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutProvider"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/context/LayoutContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/context/SessionContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["UIProvider"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/context/UIContext.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/styles/GlobalStyles.css");
